import { render, staticRenderFns } from "./CalculationFiles.vue?vue&type=template&id=513b9bb7&scoped=true"
import script from "./CalculationFiles.vue?vue&type=script&lang=js"
export * from "./CalculationFiles.vue?vue&type=script&lang=js"
import style0 from "./CalculationFiles.vue?vue&type=style&index=0&id=513b9bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b9bb7",
  null
  
)

export default component.exports